<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="edit-profile-dialog"
      :open.sync="openDialog"
      :form-ref.sync="profileFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Modifier un profile</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container>
          <profile-form
            :profile-form="profileForm"
            :attributes-choice="attributesChoice"
            :rules="rules"
          ></profile-form>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.close`]>Annuler</template>
      <template v-slot:[`dialog.actions.save`]>Enregistrer</template>
    </base-dialog>
  </div>
</template>
<script>
import { onMounted, computed, ref, toRefs } from "@vue/composition-api";
import BaseDialog from "@/components/General/BaseDialog.vue";
import { useProfile } from "../../composables/profile";
import ProfileForm from "./ProfileForm";

export default {
  components: {
    ProfileForm,
    BaseDialog,
  },
  props: {
    profile: Object,
    partner: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { profileData, updateProfile, attributesChoice } = useProfile();

    /* Variables */
    const { label, description, attributes } = props.profile;

    /* Cycle de vie */
    onMounted(() => {
      profileData.profileForm = {
        label,
        description,
        attributes: attributes.map((attribute) => {
          delete attribute.id;
          delete attribute.profile;
          return attribute;
        }),
      };
    });

    const openDeleteDialog = ref(false);
    const openLoadingDialog = ref(false);

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const saveItem = async function () {
      await updateProfile(props.profile);
      openDialog.value = false;
    };

    return {
      saveItem,
      openDialog,
      openLoadingDialog,
      openDeleteDialog,
      ...toRefs(profileData),
      attributesChoice,
    };
  },
};
</script>
